import React, {Fragment} from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import styled from 'styled-components';
import numberFormatter from 'utils/numberFormatter';
import TableButtonBar from './TableButtonBar';

const StyledTableCell = styled(TableCell)`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    padding: 4px 20px 4px 24px;
  }
`
const GridPricingRow = ({row, className}) => (
  <TableRow key={row.id} className={className}>
    <StyledTableCell component="th" scope="row">{numberFormatter.formatRate(row.strike,2)}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatMoney(row.marketCostTwelveMonths,0,'-')}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatMoney(row.marketCostTwentyFourMonths,0,'-')}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatMoney(row.marketCostThirtySixMonths,0,'-')}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatMoney(row.marketCostFortyEightMonths,0,'-')}</StyledTableCell>
  </TableRow>
);

const PercentGridPricingRow = ({row, notional, className}) => {
  let marketCostTwelveMonthRate = null;
  let marketCostTwentyFourMonthRate = null;
  let marketCostThirtySixMonthRate = null;
  let marketCostFortyEightMonthRate = null;
  if(row.marketCostTwelveMonths !== null){
    marketCostTwelveMonthRate = row.marketCostTwelveMonths/notional;
  }
  if(row.marketCostTwentyFourMonths !== null){
    marketCostTwentyFourMonthRate = row.marketCostTwentyFourMonths/notional;
  }
  if(row.marketCostThirtySixMonths !== null){
    marketCostThirtySixMonthRate = row.marketCostThirtySixMonths/notional;
  }
  if(row.marketCostFortyEightMonths !== null){
    marketCostFortyEightMonthRate = row.marketCostFortyEightMonths/notional;
  }
  return(
  <TableRow key={row.id} className={className}>
    <StyledTableCell component="th" scope="row">{numberFormatter.formatRate(row.strike,2)}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatRate(marketCostTwelveMonthRate,3,'-')}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatRate(marketCostTwentyFourMonthRate,3,'-')}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatRate(marketCostThirtySixMonthRate,3,'-')}</StyledTableCell>
    <StyledTableCell>{numberFormatter.formatRate(marketCostFortyEightMonthRate,3,'-')}</StyledTableCell>
  </TableRow>
)}

const StyledTableHead = styled(TableHead)`
  && {
    /* Work Sans / 12 Semibold CAPS */
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    background: #FAFAFA;
    border-bottom: 3px solid #ccc;
} 
&& th {
  color: #5F6368;
  }
`
const AnchorRow = styled(GridPricingRow)`
  ${TableRow} {    
    background:#0F9AD6;    
  }
  && ${TableRow} th, td {
    font-weight:bold;
  }
`
const PercentAnchorRow = styled(PercentGridPricingRow)`
  ${TableRow} {    
    background:#0F9AD6;    
  }
  && ${TableRow} th, td {
    font-weight:bold;
  }
`
class GridPricing extends React.Component {

  BY_DOLLAR = 0;
  BY_PERCENT = 1;

  state = {
    radioVal: 0
  };

  options = [{
    name: 'By Dollar',
    value: this.BY_DOLLAR
  },{
    name: 'By Percent',
    value: this.BY_PERCENT
  }];

  handleChange = (e) => {
    let val = e.target.value;
    this.setState({
      radioVal: val
    })
  }

  render() {
    const {capResult} = this.props;
    const {radioVal} = this.state;
    if(!capResult){
      return null;
    }
    let rows = capResult.capPrices;
    return (    
    <Fragment>
      <TableButtonBar
        radioVal={radioVal}
        options={this.options}
        handleChange={this.handleChange}
      />
      <Table>
        <StyledTableHead>
          <TableRow>
            <StyledTableCell>Strike</StyledTableCell>
            <StyledTableCell>12 Months</StyledTableCell>
            <StyledTableCell>24 Months</StyledTableCell>
            <StyledTableCell>36 Months</StyledTableCell>
            <StyledTableCell>48 Months</StyledTableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {radioVal == this.BY_DOLLAR && rows.map((row,i) => this.renderByDollar(row,i))}
          {radioVal == this.BY_PERCENT && rows.map((row,i) => this.renderByPercent(row, capResult,i))}
        </TableBody>
      </Table>    
    </Fragment>
    )
  }

  renderByDollar = (row,i) => {
    if(row.isAnchor){          
      return (<AnchorRow key={i} row={row}/>);
    }
    return (<GridPricingRow key={i} row={row}/>);
  }

  renderByPercent = (row, capResult,i) => {
    let {notional} = capResult;
    if(row.isAnchor){          
      return (<PercentAnchorRow key={i} notional={notional} row={row}/>);
    }
    return (<PercentGridPricingRow key={i} notional={notional} row={row}/>);
  }
}

export default GridPricing;